<script setup lang="ts">
import { useStore } from "@/store";
import { onMounted, ref } from "vue";
import { GetRuleConfig } from "@/data/ruleConfig";
import { loadRuleConfig, getInfoText } from "@/rules/ruleEngine";
const store = useStore();

const homeText = ref(getInfoText("home"));

onMounted(async () => {
  try {
    const cfg = await GetRuleConfig();
    loadRuleConfig(cfg);
  } catch (error) {
    console.error("Error loading info text:", error);
  }
  homeText.value = getInfoText("home");
});
</script>

<template>
  <v-container>
    <h3 class="w-100 text-center mb-4">Willkommen auf dem Wunschdienstplan</h3>
    <v-container>
      <div v-html="homeText"></div>
    </v-container>
    
    <v-container class="mt-4 mb-8 d-flex align-center flex-column">
      <small class="mb4"><b>Hier können Sie Ihre Wünsche eingeben.</b></small>
      <v-row>
        <v-col cols="12" class="mb-2"  v-if="store.getters.isWDP || store.getters.isAdmin">
          <v-btn :to="{ name: 'wuensche' }" color="primary" min-width="260px">Wunschdienstplan</v-btn>
        </v-col>
        <v-col cols="12" class="mb-2"  v-if="store.getters.isUP || store.getters.isAdmin">
          <v-btn :to="{ name: 'urlaubswuensche' }" color="primary" min-width="260px">Urlaubswünsche</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<style scoped>

</style>